<template>
  <div class="swiper-wrap">
    <div class="swiper-container" v-if="articleSwiper.length">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide class-wrap"
          v-for="item in articleSwiper"
          :key="item.ID"
        >
          <div
            class="class-item"
            v-for="classItem in item"
            :key="classItem.ID"
            @click="handleClassSelect(classItem)"
          >
            <img
              :src="
                classItem.CLASS_ICON ? classItem.CLASS_ICON : getIco('homeicon')
              "
              class="ico"
              alt="class-icon"
            />
            <p class="text" :class="{ active: activeClassId == classItem.ID }">
              {{ classItem.CLASS_NAME_MULTILINGUAL }}
            </p>
          </div>
        </div>
      </div>
      <div class="swiper-pagination" v-if="articleSwiper.length > 1"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick, computed } from "vue";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import useLang from "@hooks/useLang";
import { getIco } from "@config/siteConfig";
const props = defineProps({
  classList: {
    default: [],
  },
  activeClassId: {
    default: null,
  },
});

const emits = defineEmits(["selectClass"]);

const { lang } = useLang();
// 将classList分成4个一组
const newClassList = computed(() => {
  return props.classList.reduce((prev, cur, index) => {
    const groupIndex = Math.floor(index / 4);
    if (!prev[groupIndex]) {
      prev[groupIndex] = [];
    }
    prev[groupIndex].push(cur);
    return prev;
  }, []);
});

const articleSwiper = ref(newClassList);

let unwatch = null;
unwatch = watch(
  articleSwiper,
  () => {
    if (articleSwiper.value.length) {
      nextTick(() => {
        initSwiper();
        unwatch && unwatch();
      });
    }
  },
  {
    immediate: true,
  }
);

const handleClassSelect = (item) => {
  emits("selectClass", item);
};

const initSwiper = () => {
  new Swiper(".swiper-container", {
    loop: false,
    autoplay: false,
    direction: "horizontal",
    pagination: {
      el: ".swiper-pagination",
    },
    effect: "slide", // flip:3d翻转  slide:位移切换  fade:淡入  cube:方块  coverflow:3d流
    observer: true,
    observeParents: true,
  });
};
</script>

<style scoped lang="scss">
@import "@assets/scss/dimen.scss";
@import "@assets/scss/mixin.scss";
.class-wrap {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));
  grid-auto-flow: row;
  gap: 0;
  justify-items: center;
  align-items: flex-start;
  margin-top: 55px;
  .class-item {
    display: flex;
    flex-direction: column;
    width: 187px;
    height: 111px;
    margin-bottom: 55px;
    align-items: center;
    cursor: pointer;
    @include addTouchEffect();
    .ico {
      height: 60px;
      margin: 0 auto 20px;
    }
    .text {
      font-size: $fzNormal;
      color: $titlecolor;
      width: 98%;
      text-align: center;
      word-break: break-all;
      &.active {
        color: $maincolor;
      }
    }
  }
}

.swiper-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

@media (orientation: landscape) {
  .class-wrap {
    margin-top: 0;
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .class-wrap {
    .class-item {
      width: calc(187px / $pcRate);
      height: calc(111px / $pcRate);
      margin-bottom: calc(55px / $pcRate);
      .ico {
        height: calc(60px / $pcRate);
      }
      .text {
        font-size: $fzNormalPc;
      }
    }
  }
}
</style>

<style lang="scss">
.swiper-pagination-bullet {
  display: inline-block;
  width: 13px;
  height: 12px;
  background: #a4a4a2;
}
.swiper-pagination-bullet-active {
  display: inline-block;
  width: 27px;
  height: 12px;
  background: #4aa7ff;
  border-radius: 40px;
}
</style>
